export const taxDict = {
    // 订单状态
    orderStatus: {
        0: {color: '#8c8c8c', label: '服务费待处理'},  // 改为灰色，表示等待
        1: {color: '#1890ff', label: '待分配'},
        2: {color: '#52c41a', label: '已完成'},
        3: {color: '#ff4d4f', label: '支付失败/已作废'},
        default: {color: '#bfbfbf', label: '未知'},
    },
    // 服务费归集状态 (payment_status)
    serviceFeeStatus: {
        0: {color: '#8c8c8c', label: '待处理'},
        1: {color: '#1890ff', label: '处理中'},
        2: {color: '#52c41a', label: '成功'},
        3: {color: '#ff4d4f', label: '失败'},
        default: {color: '#bfbfbf', label: '未知'},
    },
    // 分润状态 (payment_status)
    profitShareStatus: {
        0: {color: '#8c8c8c', label: '待处理'},
        1: {color: '#1890ff', label: '处理中'},
        2: {color: '#52c41a', label: '成功'},
        3: {color: '#ff4d4f', label: '失败'},
        default: {color: '#bfbfbf', label: '未知'},
    },
};